import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import {
  Participant, Preference, PREFERENCE_LABELS, SessionGroup, peaksFor,
} from '../../invitations/models/invitation.model';

@Component({
  selector: 'app-session-group-column',
  templateUrl: './session-group-column.component.html',
  styleUrls: ['./session-group-column.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SessionGroupColumnComponent {
  @Input() group!: SessionGroup;
  /** Resolved members in group order — the column never looks ids up itself. */
  @Input() members: Participant[] = [];
  /** An array, deliberately: Angular does not track mutations of a Set. */
  @Input() selectedIds: string[] = [];
  /** ids of the other drop lists, so CDK allows list-to-list transfer. */
  @Input() connectedTo: string[] = [];
  /**
   * Whether THIS column's cog menu is open. A column can't enforce mutual exclusion against its
   * siblings on its own, so the board owns the open/closed state and passes it down.
   */
  @Input() menuOpen = false;
  /**
   * Whether the GROUP itself is selected. Independent of `selectedIds`, which selects individual
   * participants: you pick groups to act on whole groups (downloading their reports), and
   * participants to act on people (moving them between groups).
   */
  @Input() selected = false;

  /** The group's own checkbox was toggled. */
  @Output() toggleSelect = new EventEmitter<void>();
  @Output() toggleMember = new EventEmitter<string>();
  @Output() rename = new EventEmitter<string>();
  @Output() remove = new EventEmitter<void>();
  @Output() selectAll = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();
  @Output() dropped = new EventEmitter<CdkDragDrop<SessionGroup>>();
  /** Cog was clicked — ask the board to open this column's menu (and close any other). */
  @Output() menuToggle = new EventEmitter<void>();
  /** An action inside the menu was taken — ask the board to close it. */
  @Output() menuClose = new EventEmitter<void>();

  editing = false;
  draftName = '';

  readonly prefLabels = PREFERENCE_LABELS;

  isSelected(id: string): boolean { return this.selectedIds.includes(id); }

  /** The preferences this person is high in — their profile type IS the peak set. */
  peaks(p: Participant): Preference[] { return peaksFor(p.profileTypeId); }

  startRename(): void {
    this.menuClose.emit();
    this.editing = true;
    this.draftName = this.group.name;
  }
  commitRename(): void {
    this.editing = false;
    const n = this.draftName.trim();
    if (n && n !== this.group.name) { this.rename.emit(n); }
  }
}
